import { useManagePaymentMethods } from "../ManagePaymentMethodsContext";

export default function usePaymentMethods() {
  const { state, dispatch } = useManagePaymentMethods();
  let paymentMethods = state.paymentMethods;

  const setPaymentMethods = (paymentMethods) => {
    dispatch({ type: "Set Payment Methods", payload: paymentMethods });
  };

  return [paymentMethods, setPaymentMethods];
}
